import React from "react";
import Button from "../ui/Button";
import { ModalShell, ModalHeader } from "../ui/ModalFrame";
import { MODAL_LAYER } from "../../constants/modalLayers";
import { MODAL_DIALOG_ACTIONS_END } from "../../constants/layoutSpacing";
import { cn } from "../../utils/cn";
import NeoAiDiffPreview from "./NeoAiDiffPreview";
import { pickDiffTexts } from "../../utils/neoAiTextDiff";

function PreviewBlock({ label, text, highlight }) {
  return (
    <div className="flex flex-col min-h-0 flex-1">
      <p className="text-xs font-medium text-muted-foreground mb-2">{label}</p>
      <pre
        className={cn(
          "flex-1 min-h-[120px] max-h-[40vh] overflow-auto rounded-lg border border-border bg-muted/30 p-3 text-xs whitespace-pre-wrap font-mono leading-relaxed",
          highlight && "border-primary/40 bg-primary/5"
        )}
      >
        {text || "—"}
      </pre>
    </div>
  );
}

const NeoAiEditPreviewModal = ({
  open,
  onClose,
  onConfirm,
  before = "",
  after = "",
  incomingOnly,
  summary,
  changedSegmentBefore,
  changedSegmentAfter,
  applying = false,
}) => {
  if (!open) return null;

  const showSideBySide = !incomingOnly && before !== after;
  const incoming = incomingOnly || "";

  const diffSource = pickDiffTexts({
    before,
    after,
    changedSegmentBefore,
    changedSegmentAfter,
    summary,
  });

  const showDiff =
    !incoming &&
    summary !== "insert_at_cursor" &&
    summary !== "plain_insert" &&
    diffSource.before !== diffSource.after;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/55"
      panelClassName="bg-card rounded-xl max-w-4xl w-full max-h-[90vh] flex flex-col shadow-elevation-xl border border-border"
    >
      <ModalHeader title="Revisar alteração da IA" onClose={onClose} />
      <div className="px-5 py-4 space-y-3 overflow-y-auto flex-1 min-h-0">
        <p className="text-sm text-muted-foreground">
          Confira o texto antes de aplicar no editor. Neo Coins já foram consumidos neste pedido.
        </p>
        {summary === "insert_at_cursor" || summary === "plain_insert" ? (
          <PreviewBlock label="Texto sugerido pela IA (será inserido)" text={incoming} highlight />
        ) : showDiff ? (
          <NeoAiDiffPreview
            before={diffSource.before}
            after={diffSource.after}
            focused={diffSource.focused}
          />
        ) : showSideBySide ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <PreviewBlock label="Antes" text={before} />
            <PreviewBlock label="Depois" text={after} highlight />
          </div>
        ) : (
          <PreviewBlock label="Conteúdo" text={after || before} highlight />
        )}
      </div>
      <div className={cn(MODAL_DIALOG_ACTIONS_END, "px-5 py-4 border-t border-border")}>
        <Button type="button" variant="outline" onClick={onClose} disabled={applying}>
          Descartar
        </Button>
        <Button type="button" onClick={onConfirm} loading={applying}>
          Aplicar no editor
        </Button>
      </div>
    </ModalShell>
  );
};

export default NeoAiEditPreviewModal;
